import ImageBuilding from "../../ImageBuilding/ImageBuilding";
import React from "react";

import {useTranslationContext} from "../../../../react/providers/TranslationContext";

type Props = {
    gid: number,
    setSelectedBuilding?: (gid: number|null) => void,
}

export function BuildingRequirementNotBuilding({gid, setSelectedBuilding}: Props) {
    const {translate} = useTranslationContext();

    function handleClick(e: React.MouseEvent) {
        e.preventDefault();
        setSelectedBuilding(gid);
    }

    return <div className='d-flex align-items-center gap-2'>
        <ImageBuilding gid={gid} size={24} grayscale={true} />
        <s><a onClick={handleClick} href=''>{translate('building_g' + gid)}</a></s>
    </div>
}
